import React, {useContext, useEffect} from "react";
import Aos from 'aos'
import {Carcontext} from "../context/carcontext";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import { fCurrency } from "../utils";

const Cars = ({ car }) => {

    const {t} = useTranslation()
    const isLoggedIn = useSelector(state => state.clients.isLoggedIn)

    useEffect(() => {
        Aos.init()
    }, [])

    const { OpenCarModal, theme } = useContext(Carcontext);

    return (
        <div className="animation" data-aos="zoom-out-up">
            <div className={`card ${theme}`} onClick={e => OpenCarModal(car)}>
                <div className="card-imagebox">
                    <img className="card-image" src={`https://rezilizer.ru/${car.photo}`} alt="Vehicle" />
                </div>
                <h3 className="card-title">
                    {car.brand} {car.model}
                </h3>
                <p className="card-number">
                    {car.car_num}
                </p>
                <p className="card-price">
                    {fCurrency(car.rent_cost)}
                    {t('price/day')}
                </p>
                {
                    (() => {
                        if (isLoggedIn === true && car.status === 'vacant') {
                            return <button className="rent-btn">{t('rent')}</button>
                        }
                        if (car.status !== 'vacant' && isLoggedIn === true) {
                            return <button className="rent-btn disabled">{t('rent')}</button>
                        }
                        if (car.status === 'reserved' && isLoggedIn === true) {
                            return <button className="rent-btn disabled">{t('rent')}</button>
                        }
                    }) ()
                }
                <div className="card-dots"></div>
            </div>
        </div>
    )
};

export default Cars;
